import { React, useState, useEffect } from 'react'
import "./email.css"
import ApiServiceInv from "../../services/apiService";
import { PropagateLoader } from 'react-spinners';

const EmailApproval = () => {
    const apiService = new ApiServiceInv();
    const [docData, setDocData] = useState([]);
    const [datamsgs, setData] = useState();
    const [loader, setloader] = useState(true);
    const [expired, setExpired] = useState(true);
    const handleApprove = async (params) => {
        const { token, docNo, srNo, docType, status } = params;
        try {
            const queryParams = `?token=${token}&docNo=${docNo}&srNo=${srNo}&docType=${docType}&status=${status}`;
            const response = await apiService.getApiParamater("GET_DOC_VERIFY", queryParams);

            if (response?.data?.message === 'Token is expired!') {
                setExpired(true)
                setData(response?.data?.message)
            } else if (response?.data?.message === 'Requisition is already Approved') {
                setExpired(true)
                setData(response?.data?.message)
            } else if (response?.data?.message === 'Requisition is already Rejected') {
                setExpired(true)
                setData(response?.data?.message)
            } else if (response?.data?.message === 'Requisition is already Hold') {
                setExpired(true)
                setData(response?.data?.message)
            } else {
                setData(response?.data?.message)
            }
            setloader(false)
            console.log(response, "API Response");
        } catch (error) {
            console.error(error, "Error occurred while calling the API");
        }
    };

    useEffect(() => {
        const url = window.location.href;
        const regex = /token=([^&]+)&docNo=([^&]+)&srNo=([^&]+)&docType=([^&]+)&status=([^&]+)/;
        const match = url?.match(regex);
        if (match) {
            const params = {
                token: match[1],
                docNo: match[2],
                srNo: match[3],
                docType: match[4],
                status: match[5],
            };
            setDocData(params)
            handleApprove(params);
        }
    }, []);

    return (
        <div className='p-5 center'>
            <div class="card ">
                <div class="headerss">
                    <div class="logos">Pro360</div>
                    <div class="inventorys">Inventory</div>
                </div>
                {loader === true ?
                    <div>
                        <PropagateLoader
                            color="#884b9d"
                            size={15}
                        />
                    </div> :
                    <div>
                        {expired === false ?
                            <div>
                                <div class="main-message">
                                    Your Document No # {docData?.docNo} has been {docData?.status === "1" ? "Approved" : docData?.status === "2" ? "Rejected" : docData?.status === "5" ? "Hold" : ""} Successfully
                                </div>
                                <div class="subtext">
                                    Your Document <span>{docData?.docNo}</span> has been {docData?.status === "1" ? "Approved" : docData?.status === "2" ? "Rejected" : docData?.status === "5" ? "Hold" : ""} and you can now log in to your account.<br /><br />
                                    You can now access Procurement online or on any device by going to <br />
                                    <a href="https://proc.pro360.freemyip.com" class="linkss">https://proc.pro360.freemyip.com</a>
                                </div>
                            </div> :
                            <div>
                                <div class="main-message">
                                    {datamsgs}
                                </div>
                                <div class="subtext">
                                    You can now access Procurement online or on any device by going to <br />
                                    <a href="https://proc.pro360.freemyip.com" class="linkss">https://proc.pro360.freemyip.com</a>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    );
};

export default EmailApproval;